import classNames from "classnames";
import React, { ReactElement, useEffect, useState } from "react";
import { ARTICLES } from "../../../components/help/Help";
import useArticleContext from "../../../contexts/HelpContext";
import Styles from "../Onboarding.module.scss";
import { ChoiceButton, StepProps } from "./base";

export default function OnboardingStep(props: StepProps): ReactElement {
    const [isCreateForMe, setCreateForMe] = useState<boolean | undefined>(true);

    useArticleContext(ARTICLES.CONTACTED_PAGE);

    useEffect(() => {
        const shouldCreateDemoChannel = props.profile.shouldCreateDemoChannel ?? true;
        setCreateForMe(shouldCreateDemoChannel);
        if (shouldCreateDemoChannel) {
            props.onDone({ ...props.profile, shouldCreateDemoChannel });
        } else {
            props.onNext({ ...props.profile, shouldCreateDemoChannel });
        }
    }, []);
    return (
        <div>
            <div className={Styles["step-header"]}>
                <h2 className={Styles["step-title"]}>Channel Setup Options</h2>
                <p>
                    Choose how you would like to set up your channel. You can let the system create it
                    for you automatically, or configure it manually
                    for more customization and control.
                </p>
            </div>

            <div className={classNames(Styles["common-task-list"])}>
                <ChoiceButton
                    isSelected={isCreateForMe === true}
                    metricPath={["onboarding", props.stepId, "channel-create", "automatic"]}
                    onSelected={() => {
                        props.onDone({ ...props.profile, shouldCreateDemoChannel: true });
                        setCreateForMe(true);
                    }}
                >
                    Create the Channel for Me
                    <small>
                        Automatically set up a new channel with the necessary configurations.
                    </small>
                </ChoiceButton>

                <ChoiceButton
                    isSelected={isCreateForMe === false}
                    metricPath={["onboarding", props.stepId, "channel-create", "manual"]}
                    onSelected={() => {
                        props.onNext({ ...props.profile, shouldCreateDemoChannel: false });
                        setCreateForMe(false);
                    }}
                >
                    Configure the Channel Manually
                    <small>
                        Set up the channel yourself with custom configurations tailored to your needs.
                    </small>
                </ChoiceButton>
            </div>

        </div>
    );
}
